"use strict";
exports.__esModule = true;
var core_1 = require("@tiptap/core");
exports["default"] = core_1.Node.create({
    name: "variable",
    group: "inline",
    inline: true,
    content: "text*",
    atom: true,
    draggable: true,
    defaultOptions: {
        id: "",
        name: undefined,
        "class": "custom-variable",
        contenteditable: "false",
        HTMLAttributes: {
            "class": "custom-variable",
            contenteditable: "false"
        }
    },
    addAttributes: function () {
        return {
            id: {
                "default": ""
            },
            name: { "default": null },
            "class": "custom-variable",
            contenteditable: "false"
        };
    },
    parseHTML: function () {
        return [
            {
                tag: 'span[class="custom-variable"]'
            }
        ];
    },
    renderHTML: function (_a) {
        var HTMLAttributes = _a.HTMLAttributes, node = _a.node;
        HTMLAttributes["class"] = this.options.HTMLAttributes["class"];
        HTMLAttributes.contenteditable = "false";
        return ["span", HTMLAttributes, "{" + HTMLAttributes.name + "}"];
    },
    addCommands: function () {
        var _this = this;
        return {
            setVariableSpan: function (options) {
                return function (_a) {
                    var tr = _a.tr, dispatch = _a.dispatch;
                    var selection = tr.selection;
                    options.id = "x_" + options.id;
                    var node = _this.type.create(options);
                    if (dispatch) {
                        tr.replaceRangeWith(selection.from, selection.to, node);
                    }
                    return true;
                };
            }
        };
    }
});
